import styleInject from '../../external/style-inject/dist/style-inject.es.js';

var css_248z = ".TileSkeleton-module_tile__9WM2p {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 142px;\n  height: 102px;\n  padding: 24px 22px 16px 16px;\n}\n\n.TileSkeleton-module_icon__ZA5Y- {\n  width: 32px;\n  height: 32px;\n  border-radius: 5px;\n  background-color: #f5f6f8;\n}\n\n.TileSkeleton-module_title__7U1Ol {\n  width: 104px;\n  height: 22px;\n  border-radius: 5px;\n  background-color: #f5f6f8;\n}";
var styles = {"tile":"TileSkeleton-module_tile__9WM2p","icon":"TileSkeleton-module_icon__ZA5Y-","title":"TileSkeleton-module_title__7U1Ol"};
styleInject(css_248z);

export { styles as default };
